import { render, staticRenderFns } from "./UploadFileModal.vue?vue&type=template&id=4589e8bb&"
import script from "./UploadFileModal.vue?vue&type=script&lang=js&"
export * from "./UploadFileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4589e8bb')) {
      api.createRecord('4589e8bb', component.options)
    } else {
      api.reload('4589e8bb', component.options)
    }
    module.hot.accept("./UploadFileModal.vue?vue&type=template&id=4589e8bb&", function () {
      api.rerender('4589e8bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/condoMngt/component/UploadFileModal.vue"
export default component.exports